<template>
  <path d="M22.06,19.74l-7.7-7.63L22,4.42,19.61,2.06,12,9.76,4.29,2.14,1.94,4.5l7.7,7.63L2,19.83l2.36,2.36L12,14.48l7.7,7.63Z"/>
</template>

<script>
export default {
  name: 'Icon' + 'Cancel'
};
</script>
